import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';

//import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router} from 'react-router-dom';
import { createBrowserHistory } from "history";
import { AppContextProvider} from './hooks/AppContext'
import { RouteContextProvider} from './hooks/RouteContext'
import { SearchParamContextProvider } from './hooks/SearchParamContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

document.title = process.env.REACT_APP_NOME||"QR Tot"
const history = createBrowserHistory();

root.render(
  <Router history={history}>
    <RouteContextProvider>
      <AppContextProvider>    
        <SearchParamContextProvider>      
          <App nomeSistema={process.env.REACT_APP_NOME ||"QR Tot"} versao={process.env.REACT_APP_VERSAO ||"0.0"} info={process.env.REACT_APP_INFO} data={process.env.REACT_APP_DATA}/>      
        </SearchParamContextProvider>      
      </AppContextProvider>
    </RouteContextProvider>
  </Router>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
